export default __webpack_public_path__ + "static/zt-award-group-c012678c4fbdedd4ca65d2501adadb72.png";